<template>
  <div class="Page">
    <div class="Page-Content" style="overflow: hidden;">
      <iframe style="width: 100%;height: 100%;padding: 0;margin: 0;" src="./siteplan19.html" frameborder="0"></iframe>
    </div>
    <!-- <img style="height: 100%;" src="@/assets/media/facilities.png" alt=""> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods:{

  },
  mounted(){

  },
}
</script>

<style lang="less">
  
</style>

